import React, { ReactNode } from 'react'
import { CustomErrorSpan } from '../../../style/styled'

export default function CustomErrorMessage({ children }: any) {
  return <CustomErrorSpan variant="danger">{children}</CustomErrorSpan>
}
